import clsx from 'clsx';
import React from 'react';
import { Theme } from '@/utils/constants';

import { withPortalBoxFeatures } from '../shared/HOCs';

import { BREADCRUMB_BOX_PORTAL_EVENT, BREADCRUMB_BOX_PORTAL_ID } from './Breadcrumb.constants';
import { breadcrumbBoxStyles } from './Breadcrumb.styles';

const BreadcrumbBox = withPortalBoxFeatures(
  ({ theme = Theme.light, className, ...restProps }) => {
    const classes = breadcrumbBoxStyles();

    return (
      <div
        data-datalayer-position="breadcrumb"
        className={clsx(className, classes.root, `${theme}-theme`)}
        style={{ width: 'auto' }}
        {...restProps}
      />
    );
  },
  {
    boxId: BREADCRUMB_BOX_PORTAL_ID,
    readyEventName: BREADCRUMB_BOX_PORTAL_EVENT,
  },
);

export default BreadcrumbBox;
